<template>
  <footer v-if="summary || notice || loading || error || hasMore || $slots.actions || fullText" class="ai-common-list-footer">
    <div v-if="summary || notice || loading || error || hasMore" class="summary-row" :style="{ height: informationHeight + 'px' }">
      <div class="summary-copy">
        <button v-if="summary" class="information" :title="summary" @click="showInformation($event, summary)">{{ summary }}</button>
        <button v-if="notice" class="information" :class="{ 'notice-after-summary': summary }" :title="notice" @click="showInformation($event, notice)">{{ notice }}</button>
      </div>
      <div class="status-slot">
        <span v-if="loading" role="status">加载中…</span>
        <button v-else-if="error" :disabled="busy" aria-label="加载失败，点击重试" @click="!busy && $emit('more')"><span>加载失败，重试</span></button>
        <span v-else-if="hasMore && overflow" class="hint">下滑加载更多</span>
        <button v-else-if="hasMore" :disabled="busy" @click="!busy && $emit('more')"><span>加载更多</span></button>
      </div>
    </div>
    <div v-if="$slots.actions" class="footer-actions"><slot name="actions" /></div>
    <confirm-dialog :visible="!!fullText" title="完整信息" :message="fullText" :show-cancel="false" confirm-text="关闭"
      :close-on-click-mask="true" @confirm="fullText = ''" @cancel="fullText = ''" />
  </footer>
</template>
<script>
import ConfirmDialog from '@/components/common/confirm-dialog/confirm-dialog.vue'
// Presentation only: request admission and selection remain owned by callers.
export default {
  components: { ConfirmDialog },
  props: { summary: String, notice: String, loading: Boolean, error: [Boolean, String], hasMore: Boolean, overflow: Boolean, busy: Boolean },
  data: () => ({ fullText: '' }),
  computed: { informationHeight () { return this.summary && this.notice ? 44 : 20 } },
  methods: {
    showInformation (event, text) {
      const element = event && event.currentTarget
      if (element && element.scrollWidth > element.clientWidth) this.fullText = text
    }
  }
}
</script>
<style scoped>
.ai-common-list-footer { display:block; border-top:1px solid #e1e5ec; margin-top:8px; padding-top:8px; color:#637189; font-size:12px; line-height:20px; }
.summary-row { display:flex; align-items:flex-start; justify-content:space-between; gap:8px; min-height:20px; }
.summary-copy { flex:1; min-width:0; }
.information { display:block; width:100%; height:20px; padding:0; border:0; background:transparent; color:inherit; font:inherit; line-height:20px; text-align:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; cursor:pointer; }
.notice-after-summary { margin-top:4px; }
.status-slot { flex:0 0 min(132px,48%); min-width:0; min-height:20px; display:flex; align-items:flex-start; justify-content:flex-end; text-align:right; }
.status-slot > span, .status-slot > button { display:block; max-width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.status-slot button { border:0; padding:0; height:20px; background:transparent; color:#174b91; font:inherit; line-height:20px; text-align:right; cursor:pointer; display:flex; align-items:flex-start; }
.status-slot button span { display:block; max-width:100%; overflow:hidden; white-space:nowrap; text-overflow:ellipsis; }
.status-slot button:disabled { opacity:.5; cursor:default; }
.ai-common-list-footer ::v-deep .common-confirm-message { max-height:45vh; overflow:auto; white-space:pre-wrap; }
.footer-actions { display:flex; justify-content:flex-end; gap:8px; margin-top:6px; }
.footer-actions ::v-deep button { min-width:0; max-width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
</style>
